module.exports = __webpack_public_path__ + "static/media/card-image-1.a2b68f85.jpg";